type FontSpec = { family: string; weight?: number; style?: string };

/**
 * 앱/웹 공통: 시작 시 폰트를 강제로 로드해두는 함수
 * - document.fonts.load 로 폰트 로드 트리거
 * - document.fonts.ready 로 최종 준비까지 대기
 */
export async function preloadFonts(
  specs: FontSpec[] = [
    { family: "Luckiest Guy", weight: 400, style: "normal" },
    { family: "Gaegu", weight: 400, style: "normal" },
    { family: "Black Han Sans", weight: 400, style: "normal" },
  ],
) {
  // document.fonts가 없는 구형 환경 방어
  const fonts = (document as any).fonts as FontFaceSet | undefined;
  if (!fonts?.load) return;

  // Phaser에서 보통 큰 사이즈를 쓰니까 큰 사이즈로 로드 트리거
  const loads = specs.map((s) => {
    const weight = s.weight ?? 400;
    const style = s.style ?? "normal";
    // CSS Font Loading API 문법: "<style> <weight> <size> <family>"
    return fonts.load(`${style} ${weight} 64px "${s.family}"`);
  });

  // 로드 트리거 후, ready까지 기다리면 “텍스트 생성 시점” 문제 해결됨
  await Promise.allSettled(loads);
  await fonts.ready;
}
